"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColumnActionsMenu = void 0;
const tslib_1 = require("tslib");
const components_1 = require("@apollo/client/react/components");
const catalog_core_1 = require("@tableau/catalog-core");
const catalog_messages_1 = require("@tableau/catalog-messages");
const catalog_queries_1 = require("@tableau/catalog-queries");
const data_catalog_shared_1 = require("@tableau/data-catalog-shared");
const data_structures_1 = require("@tableau/data-structures");
const widgets_1 = require("@tableau/widgets");
const react_1 = tslib_1.__importDefault(require("react"));
const RemoteTypeIcon_1 = require("../datagrid/cellFormatters/RemoteTypeIcon");
const ReRenderPlacePageContext_1 = require("../placePage/ReRenderPlacePageContext");
const renderQueryResult_1 = require("../renderQueryResult");
const ColumnAndFieldDetailsStyles_1 = require("../style/ColumnAndFieldDetailsStyles");
const ColumnActionsMenuHelper_1 = require("./ColumnActionsMenuHelper");
const ColumnDetailsDialog_1 = require("./ColumnDetailsDialog");
const noop = () => {
    return;
};
function ColumnActionsMenu(props) {
    const [action, setAction] = react_1.default.useState(null);
    const [isDialogShowing, setIsDialogShowing] = react_1.default.useState(false);
    const columnIdsStringList = (0, data_structures_1.keySetToStringList)(props.columnIds);
    const [isCustomDialogShowing, setIsCustomDialogShowing] = react_1.default.useState(false);
    const hideCustomDialog = react_1.default.useCallback(() => setIsCustomDialogShowing(false), [setIsCustomDialogShowing]);
    const { rerender } = react_1.default.useContext(ReRenderPlacePageContext_1.ReRenderPlacePageContext);
    const { canUserSetColumnDescription } = (0, catalog_core_1.useApiRequests)();
    const { renderDataQualityDialog, renderSensitiveLabelsDialog } = (0, catalog_core_1.useUIActions)();
    const [canUpdate, setCanUpdate] = react_1.default.useState(false);
    const { customLabelCategoriesEnabled } = (0, catalog_core_1.useFeatureFlags)();
    react_1.default.useEffect(() => {
        var _a;
        canUserSetColumnDescription({ tableVizportalId: (_a = props.tableVizportalId) !== null && _a !== void 0 ? _a : '' })
            .then(r => setCanUpdate(r))
            .catch(() => {
            return;
        });
    }, [canUserSetColumnDescription, props.tableVizportalId]);
    const columnId = columnIdsStringList && columnIdsStringList[0] ? columnIdsStringList[0] : null;
    if (!columnId) {
        return null;
    }
    return (react_1.default.createElement(components_1.Query, { 
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        query: catalog_queries_1.ColumnDetailsByLuidDocument, variables: { columnId } }, result => (react_1.default.createElement(renderQueryResult_1.RenderQueryResult, { result: result, renderers: {
            renderData: data => {
                var _a;
                const column = data && data.columns && data.columns[0]
                    ? data.columns[0]
                    : null;
                if (!column) {
                    return null;
                }
                const renderDialogParams = {
                    content: {
                        contentId: column.luid,
                        contentName: (_a = column.name) !== null && _a !== void 0 ? _a : '',
                        contentType: 'column',
                        contentIcon: react_1.default.createElement(RemoteTypeIcon_1.RemoteTypeIcon, { remoteType: column.remoteType }),
                        contentIconTitle: data_catalog_shared_1.RemoteTypeMappings[column.remoteType](),
                    },
                    dismiss: () => {
                        rerender();
                    },
                };
                return (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(widgets_1.HierarchicalDropdownWidget, { type: widgets_1.DropdownButtonType.Line, label: '', menuItemInfos: (0, ColumnActionsMenuHelper_1.ColumnActionItems)({
                            columnLuid: column.luid,
                            canUpdate,
                            customLabelCategoriesEnabled,
                        }), testId: 'columns-actions-menu', onSelect: (value) => {
                            switch (value) {
                                case ColumnActionsMenuHelper_1.ColumnActions.Description:
                                case ColumnActionsMenuHelper_1.ColumnActions.Tag:
                                    setIsDialogShowing(true);
                                    setAction(value);
                                    break;
                                case ColumnActionsMenuHelper_1.ColumnActions.QualityWarning:
                                    if (column.luid) {
                                        renderDataQualityDialog(renderDialogParams).catch(_ => {
                                            return;
                                        });
                                    }
                                    break;
                                case ColumnActionsMenuHelper_1.ColumnActions.SensitiveLabels:
                                    renderSensitiveLabelsDialog(renderDialogParams).catch(_ => {
                                        return;
                                    });
                                    break;
                                case ColumnActionsMenuHelper_1.ColumnActions.CustomLabels:
                                    setIsCustomDialogShowing(true);
                                    break;
                                default:
                                    (0, catalog_core_1.assertUnreachable)(value);
                                    throw new Error('Unreachable - unknown column action in dropdown menu');
                            }
                        }, style: ColumnAndFieldDetailsStyles_1.columnActionsMenuStyle }, catalog_messages_1.Messages.Actions()),
                    isDialogShowing && (react_1.default.createElement(ColumnDetailsDialog_1.ColumnDetailsDialogQueryWrapper, { columnId: columnIdsStringList[0], tableVizportalId: props.tableVizportalId, onClose: () => setIsDialogShowing(false), afterDescriptionAndTagsChange: noop, detailsAction: action !== null && action !== void 0 ? action : undefined })),
                    isCustomDialogShowing && (react_1.default.createElement(data_catalog_shared_1.CustomLabelDialog, { contentItem: renderDialogParams.content, close: hideCustomDialog, dismiss: hideCustomDialog }))));
            },
        } }))));
}
exports.ColumnActionsMenu = ColumnActionsMenu;
//# sourceMappingURL=ColumnActionsMenu.js.map